import { Component, OnInit, Input } from '@angular/core';


export interface aRegion{
  anio: String,
  categoria: String,
  region: String,
  proyecto: String,
  responsable: String,
  link: String,
  estado: String,
  area: String,
  descripcion: String,
  ganador: String
}
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  
  @Input() messagePopup: aRegion;
  constructor() { 
  }

  ngOnInit() {
  }

  convertList(value) {
    return value.split(",");
  }

}
